import Transactions from "./Transactions";

export default Transactions;
